import { render } from "./DispBlockComponent.vue?vue&type=template&id=6dd47a5a&scoped=true"
import script from "./DispBlockComponent.vue?vue&type=script&lang=js"
export * from "./DispBlockComponent.vue?vue&type=script&lang=js"

import "./DispBlockComponent.vue?vue&type=style&index=0&id=6dd47a5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dd47a5a"

export default script